// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"2":"827604b3","178":"04c841da","359":"7cdf000b","720":"8c5ec3c0","808":"7f21848b","898":"60824e50"}[chunkId] + ".js";
};